import classNames from "classnames/bind";
import { PriorityLevel } from "../../../../AssetResults/types";
import { useTranslation } from "react-i18next";
import styles from "./CardPriority.module.scss";
import { useMemo } from "react";
import { faSquareExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface PriorityProps {
  level: PriorityLevel;
  dueDate?: string | null;
  hideAccessible?: boolean;
}

const cx = classNames.bind(styles);

export const CardPriority: React.FC<PriorityProps> = ({ level, dueDate, hideAccessible = false }) => {
  const { t } = useTranslation("content");

  const dueDateConverted = useMemo(() => (dueDate ? new Date(dueDate) : undefined), [dueDate]);

  const tabIndex = hideAccessible ? -1 : 0;

  if (level === PriorityLevel.Required || dueDateConverted) {
    return (
      <div className={cx(styles.priorityLevelWithIcon, styles.required)} data-testid="priority-required">
        <FontAwesomeIcon icon={faSquareExclamation} />
        <p
          tabIndex={tabIndex}
          className={!dueDateConverted ? styles.requiredTextWrapper : ""}
          data-testid="required-text"
        >
          {dueDateConverted
            ? `${t("priority.dueDate").toLocaleUpperCase()} ${dueDateConverted.toLocaleDateString()}`
            : t("priority.required").toLocaleUpperCase()}
        </p>
      </div>
    );
  } else if (level === PriorityLevel.Important) {
    return (
      <div className={cx(styles.priorityLevel, styles.important)} data-testid="priority-important">
        <p tabIndex={tabIndex}>{t("priority.important").toLocaleUpperCase()}</p>
      </div>
    );
  } else if (level === PriorityLevel.Normal) {
    return (
      <div className={cx(styles.priorityLevel, styles.normal)} data-testid="priority-normal">
        <p tabIndex={tabIndex}>{t("priority.normal").toLocaleUpperCase()}</p>
      </div>
    );
  } else {
    return <></>;
  }
};
